import React from 'react';

// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Components
import MeetingModeIntroModalBody from '../MeetingModeIntroModalBody/MeetingModeIntroModalBody';

export const WelcomeBackMeetingModeIntroData = {
  slides: [
    {
      slug: 'welcome-meeting-mode-slide',
      title: 'New Meeting Mode Updates!',
      imageBgColor: Colors.purple[25],
      image: Illustrations.three_people_at_table_purple_bg,
      description: `You asked, we listened! Our most requested features out now:`,
      nextBtnLabel: 'Got it',
      footer: <MeetingModeIntroModalBody version="welcome-back" />,
    },
  ],
} as NewFeatureCarouselModalType;
